import { useCallback } from 'react';

import { ActionBar, BedIcon, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { visitActionBarTranslationKeys, visitTranslationKeys } from '../../translations';

import { VisitActionBarOrder } from './VisitActionBar';

type GoToMedicalLeaveActionProps = {
   readonly visitId: number;
};

export const GoToMedicalLeaveAction = (props: GoToMedicalLeaveActionProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(false);
   const goToMedicalLeave = useCallback(
      (): void =>
         push(visitPaths.getMedicalLeavePath({ params: { visitId: props.visitId } }), {
            label: visitTranslationKeys.goBackToVisit,
         }),
      [push, props.visitId]
   );

   return (
      <ActionBar.OptionalLink
         testId={'goToMedicalLeave'}
         icon={<BedIcon />}
         label={visitActionBarTranslationKeys.medicalLeave}
         onClick={goToMedicalLeave}
         order={VisitActionBarOrder.MedicalLeave}
      />
   );
};
